function waitForElement(selector, callback) {
  const maxWait = 10000; // 10 Sek
  const interval = 100;  // alle 100ms

  const startTime = Date.now();

  const check = () => {
    const el = document.querySelector(selector);

    if (el) {
      callback(el);
    } else if (Date.now() - startTime >= maxWait) {
      console.warn(`Element "${selector}" nicht gefunden nach 10s`);
    } else {
      setTimeout(check, interval);
    }
  };

  check();
}

//1 visual "wipe" image display in offer
let url = window.location.href;

//here apply 2x, 4x and 6pc img 
const IsMagicCloth = url.indexOf("magic-wipe-xxl-bathroom-drying-cloth") > -1 || url.indexOf("magic-wipe-xxl-drying-cloth") > -1 || url.indexOf("xxl-shiny-drying-cloth-40x60cm") > -1 || url.indexOf("xxl-bathroom-drying-cloth-40x60cm-test-1") > -1;

//here, only apply "3x pc" and "6pc" img
const IsColorfulBundle = url.indexOf("xxl-bathroom-drying-cloth-colorfulbundle") > -1;

//here no imagery on the "Premium Drying Kit" (pending=?)
const IsDryingSet = url.indexOf("bathroom-starter-set") > -1 || url.indexOf("get-premium-drying-kit") > -1;

//here on the window wiper also imagery for 1pc, 2pc, 3pc
const IsWindowBrush = url.indexOf("2-in-1-screen-window-brush") > -1;

//here apply bulk imgery.
const isBulkPack = url.indexOf("bulk-cloth") > -1;

console.log("isCloth: " + IsMagicCloth + " isColorBundle :" + IsColorfulBundle + " isDryingSet :" + IsDryingSet + "isWindowBrush: " + IsWindowBrush + "isBulkPack: "+isBulkPack);


waitForElement('.kaching-bundles__bar:last-of-type .kaching-bundles__bar-radio', (element) => {
  const wrappers = document.querySelectorAll('.kaching-bundles__bar-wrapper');
  var images = [];

  if (IsMagicCloth == true) {
    images = [
      'https://i.ibb.co/TMBZxs0c/Towels1-1-comp.png',
      'https://i.ibb.co/LhnVR3dL/Towels2-2b-comp.png',
      'https://i.ibb.co/v6RwDjt4/Towels3-3-comp.png'
    ];
  }

  else if (IsColorfulBundle == true) {
    images = [
      'https://i.ibb.co/Kx5s5zqB/Towels3-comp.png',
      'https://i.ibb.co/v6RwDjt4/Towels3-3-comp.png'
    ];
  }

  else if (IsWindowBrush == true) {
    images = [
      'https://i.ibb.co/h1CsgTpx/Windowcleaner-bundleimg-copy-cop.png',
      'https://i.ibb.co/CsX3pMJR/Windowcleaner-bundleimg-2pc-comp.png',
      'https://i.ibb.co/1JGg1zjw/Windowcleaner-bundleimg-3pcs-c.png'
    ];
  }

    else if (isBulkPack == true) {
    images = [
      'https://i.ibb.co/WWHWMG2Y/1.png',
      'https://i.ibb.co/nMX8Zs3t/2.png',
      'https://i.ibb.co/W4m4WBPQ/3.png'
    ];

  }

  wrappers.forEach((wrapper, index) => {
    const button = wrapper.querySelector('.kaching-bundles__bar-main .kaching-bundles__bar-content');
    let imgexist = wrapper.querySelector('img');
    if (imgexist) return;
    if (button && images[index]) {
      const img = document.createElement('img');
      img.src = images[index];
      button.parentNode.insertBefore(img, button);
    }
  });
});

//2 revised price in ATC 27/11.




(function smartATCUpdater() {
  let lastAppliedPrice = null;      
  let previousLoopPrice = null;     
  let stableCount = 0;              // how many loops "price stayed the same" (mike: ofr stability)

  setInterval(() => {
    const current = window.kachingprice;
    if (!current) return; //only kaching products!

    //only update IF any kaching sleection made.
    const kachingselected = document.querySelector(".kaching-bundles__bar--selected");
    if (!kachingselected) return;

    const atcSpan = document.querySelector(".product-form__submit span");
    if (!atcSpan) return;

    // If price changes between loops → reset stability counter
    if (current !== previousLoopPrice) {
      stableCount = 1;
      previousLoopPrice = current;
      return; // wait for stability
    }

    // Otherwise price matches previous loop → increment stability counter
    stableCount++;

    // Must be stable for x loops
    if (stableCount < 3) return;

    // Skip if already applied to ATC
    if (current === lastAppliedPrice) return;

    // Apply price update
    const baseText = "Add to Cart";
    atcSpan.innerHTML = `${baseText} - <strong>${current}</strong>`;
    lastAppliedPrice = current;
    console.log("ATC Updated →", current);

  }, 120); 
})();

  //price in ATC regular products (non kaching) - also implemented as part of t4:
  (function smartShopifyATCUpdater() {
    let lastAppliedPrice = null;      
    let previousLoopPrice = null;     
    let stableCount = 0;              
    const STABLE_REQUIRED = 2;

    setInterval(() => {
      // Only run if NOT a Kaching product
      if (window.kachingprice) return;

      //fallback check that it is NO kaching product. only update IF no kaching product.
      const kaching = document.querySelector(".kaching-bundles");
      if (kaching) return;

      // Get current price from Shopify DOM
      const salePrice = document.querySelector(".price__sale .price-item--sale");
      const regularPrice = document.querySelector(".price-item--regular");
      const current = salePrice?.textContent?.trim() || regularPrice?.textContent?.trim() || null;

      if (!current) return;

      const atcSpan = document.querySelector(".product-form__submit span");
      if (!atcSpan) return;

      if (current !== previousLoopPrice) {
        stableCount = 1;
        previousLoopPrice = current;
        return;
      }

      stableCount++;

      if (stableCount < STABLE_REQUIRED) return;
      if (current === lastAppliedPrice) return;

      // Update ATC for regular product
      const baseText = "Add to Cart";
      atcSpan.innerHTML = `${baseText} - <strong>${current}</strong>`;
      lastAppliedPrice = current;
      console.log("Shopify ATC Updated →", current);

    }, 120);
  })();


